import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

// shared components
import PopupNotifications from 'components/shared/PopupNotifications'
import NotFound from 'components/shared/NotFound'

// components
import Home from 'components/virtual/schedule/Home'
import Header from './Header'

const OnlineScheduleRoutes = ({ basename }) => (
  <BrowserRouter basename={basename}>
    <Header />
    <PopupNotifications />
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='*' element={<NotFound />} />
    </Routes>
  </BrowserRouter>
)

export default OnlineScheduleRoutes
